import { icons, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import LocalStorageService from "../services/localStorage";
import flow from "../assets/flow.json";
var storageKey = "assurehub";
var localStorageService = new LocalStorageService(storageKey);
export var getPermission = function () {
    var _a, _b;
    // let roles: Role[] = localStorageService.getUserLoginStored().roles || [];
    var roles = ((_b = (_a = JSON.parse(localStorage.getItem(storageKey) || "{}")) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.roles) || [];
    var allPermission = roles
        ? roles.map(function (role) { return role === null || role === void 0 ? void 0 : role.permissions; }).flat()
        : [];
    return allPermission;
};
var createMenuHeader = function () {
    var pp = getPermission();
    var principalModulesMenu = pp.filter(function (p) { return p.type === "Admin-Option"; });
    var menuHeader = [];
    principalModulesMenu.map(function (p) {
        switch (p.name) {
            case "admin-sales":
                if (!menuHeader.find(function (m) { return m.id === "inicio"; })) {
                    menuHeader.push({
                        id: "inicio",
                        name: "Ventas",
                        active: true,
                    });
                }
                break;
            case "admin-repo":
                if (!menuHeader.find(function (m) { return m.id === "reporte"; })) {
                    menuHeader.push({
                        id: "reporte",
                        name: "Reportes",
                        active: false,
                    });
                }
                break;
            case "admin-module":
                if (!menuHeader.find(function (m) { return m.id === "admin"; })) {
                    menuHeader.push({
                        id: "admin",
                        name: "Administración",
                        active: false,
                    });
                }
                break;
        }
    });
    return menuHeader;
};
// const createMenuSideBar = () => {
//   const pp: Permission[] = getPermission();
//   const principalModulesMenu = pp.filter((p) => p.type === "Admin-Option");
//   let menuSideBar: NavigateStructure[] = [];
//
//   principalModulesMenu.map((p) => {
//     switch (p.name) {
//       case "admin-sales":
//         if (!menuSideBar.find((m) => m.id === "venta")) {
//           menuSideBar.push({
//             id: "venta",
//             name: "Nueva Cotización",
//             icon: icons.Shield,
//             active: true,
//             route: "/",
//             divider: false,
//           });
//         }
//
//         break;
//       case "admin-clients":
//         if (!menuSideBar.find((m) => m.id === "clientes")) {
//           menuSideBar.push({
//             id: "clientes",
//             name: "Clientes",
//             icon: icons.Person,
//             active: false,
//             route: "/clients",
//             divider: false,
//           });
//         }
//
//         break;
//       case "admin-insurance-policies-summary":
//         if (!menuSideBar.find((m) => m.id === "poliza")) {
//           menuSideBar.push({
//             id: "poliza",
//             name: "Cotizaciones",
//             icon: icons.Favorite,
//             active: false,
//             route: "/insurance-policies-summary",
//             divider: false,
//           });
//         }
//         break;
//     }
//   });
//
//   return menuSideBar;
// };
var createMenuSideBar = function () {
    var pp = getPermission();
    var principalModulesMenu = pp.filter(function (p) { return p.type === "Admin-Option"; });
    var menuSideBar = [];
    // Definir el orden deseado
    var menuOrder = [
        "admin-sales",
        "admin-clients",
        "admin-insurance-policies-summary",
    ];
    menuOrder.forEach(function (moduleName) {
        var p = principalModulesMenu.find(function (p) { return p.name === moduleName; });
        if (!p)
            return;
        switch (p.name) {
            case "admin-sales":
                if (!menuSideBar.some(function (m) { return m.id === "venta"; })) {
                    menuSideBar.push({
                        id: "venta",
                        name: "Nueva Cotización",
                        icon: icons.Shield,
                        active: true,
                        route: "/",
                        divider: false,
                    });
                }
                break;
            case "admin-clients":
                if (!menuSideBar.some(function (m) { return m.id === "clientes"; })) {
                    menuSideBar.push({
                        id: "clientes",
                        name: "Clientes",
                        icon: icons.Person,
                        active: false,
                        route: "/clients",
                        divider: false,
                    });
                }
                break;
            case "admin-insurance-policies-summary":
                if (!menuSideBar.some(function (m) { return m.id === "poliza"; })) {
                    menuSideBar.push({
                        id: "poliza",
                        name: "Cotizaciones",
                        icon: icons.Favorite,
                        active: false,
                        route: "/insurance-policies-summary",
                        divider: false,
                    });
                }
                break;
        }
    });
    return menuSideBar;
};
export var GetMenuSideBarHome = function () {
    return createMenuSideBar();
};
export var GetMenuHeader = function () {
    return createMenuHeader();
};
export var GetMenuSideBarAdministration = function () {
    var m = flow.data.adminMenu.navigationMenu;
    return m;
};
export var GetMenuSideBarReport = function () {
    var m = flow.data.reportsMenu.navigationMenu;
    return m;
};
